import {
  useEffect,
  useState
} from "react";

import {
  getAnnouncementById
} from "../services/announcementService";


const useAnnouncement = (postId) => {
  const [announcement, setAnnouncement] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState(null);

  useEffect(() => {
    if (!postId) {
      setAnnouncement(null);
      setLoading(false);
      return;
    }

    const controller = new AbortController();

    const loadAnnouncement = async () => {
      try {
        setLoading(true);
        setError(null);

        const data = await getAnnouncementById({
          postId,
          signal: controller.signal
        });

        setAnnouncement(data);
      } catch (error) {
        if (error.name !== "AbortError") {
          setError(error);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    loadAnnouncement();

    return () => {
      controller.abort();
    };
  }, [postId]);

  return {
    announcement,
    loading,
    error
  };
};


export default useAnnouncement;